import { Box, Flex, Input, Text } from "@chakra-ui/react";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CSVLink } from "react-csv";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Layout from "../../../components/dashboard/Layout";
import LogoutMenu from "../../../components/dashboard/Layout/logout-menu";
import CTable from "../../../components/Table/table";
import { getAllLecturesRequest } from "../../../modules/admin-modules/lectures/Actions";
import { paidReportRequest } from "../../../modules/superadmin-modules/reports/Actions";
import { getPaymentSubjectRequest } from "../../../modules/superadmin-modules/videos/Actions";

const PaiedReport = ({ setAdd, setSelectedData, searchTerm }) => {
  const dispatch = useDispatch();
  const [date, setDate] = useState(dayjs(new Date()).format("YYYY-MM-DD"));
  const [lectureId, setLectureId] = useState(null);
  const [paymentSubjectId, setPaymentSubjectId] = useState(null);

  useEffect(() => {
    dispatch(getAllLecturesRequest());
    dispatch(getPaymentSubjectRequest());
  }, [dispatch]);

  useEffect(() => {
    if (date || lectureId || paymentSubjectId) dispatch(paidReportRequest(date, lectureId, paymentSubjectId));
  }, [date, lectureId, paymentSubjectId, dispatch]);

  const paidReport = useSelector((state) => state.reports.paidReport);
  const iaLoading = useSelector((state) => state.reports.iaLoading);
  const lectures = useSelector((state) => state.lectures.lectures);
  const paymentSubjects = useSelector((state) => state.videos.paymentSubjects);
  const lecOptions = lectures?.map((data) => {
    return { value: data.id, label: data.title };
  });
  const paymentSubjectsOptions = paymentSubjects?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };
  const [offset, setPage] = useState(0);
  const [size, setPerPage] = useState(10);
  const [pageNumber, setPageNumber] = useState(0);
  const [selected, setSelected] = useState({
    id: "",
  });

  const viewData = (data) => {
    setSelectedData(data);
    setSelected(data);
  };

  const Data = paidReport?.map((data, index) => {
    return {
      ...data,
      index: `#${index + 1}`,
      id: data?.id,
      name: data?.name,
      group_name: data?.group?.name,
      phone: data?.phone,
      payment_subject: data?.payment_subject?.name,
      paid_amount: data?.paid_amount,
      remaining_amount: data?.remaining_amount,
      comment: data?.comment,
      scan_by: data?.scan_by,
      created_at: data?.created_at
        ? (() => {
            const date = new Date(data.created_at);
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            return `${day}-${month}-${year}`;
          })()
        : "",
    };
  });
  const columns = [
    {
      Header: "رقم الطالب",
      accessor: "index",
    },
    {
      Header: "اسم الطالب",
      accessor: "name",
    },
    {
      Header: " الدفع",
      accessor: "payment_subject",
    },
    {
      Header: " المبلغ المدفوع",
      accessor: "paid_amount",
    },
    {
      Header: " المبلغ المتبقي",
      accessor: "remaining_amount",
    },
    {
      Header: " التعليق",
      accessor: "comment",
    },
    {
      Header: " الاسيستانت",
      accessor: "scan_by"
    },
    {
      Header: " التاريخ",
      accessor: "created_at",
    },
    {
      Header: " هاتف  الطالب",
      accessor: "phone",
    },
  ];
  const headers = [
    { label: "name", key: "name" },
    { label: "payment_subject", key: "payment_subject" },
    { label: "paid_amount", key: "paid_amount" },
    { label: "remaining_amount", key: "remaining_amount" },
    { label: "comment", key: "comment" },
    { label: "scan_by", key: "scan_by" },
    { label: "phone", key: "phone" },
    { label: "created_at", key: "created_at" },
  ];
  return (
    <Layout>
      <div style={{ minHeight: "400px" }}>
        <Flex
          w="100%"
          my="30px"
          justifyContent="space-between"
          alignItems="center"
          position="relative"
          zIndex="10000000"
        >
          <Text fontSize="24px" fontWeight="600" color="main_1">
            تقرير الدفع
          </Text>
          <Flex w="60%" justifyContent="space-between" alignItems="center">
            <Select
              options={lecOptions}
              isMulti={false}
              onChange={(data) => {
                setLectureId(data?.value);
              }}
              styles={colourStyles}
              placeholder="Select lecture"
              w="30%"
            />
            <Select
              options={paymentSubjectsOptions}
              isMulti={false}
              onChange={(data) => {
                setPaymentSubjectId(data?.value);
              }}
              styles={colourStyles}
              placeholder="Select Payment Subject"
              w="30%"
              mx="8px"
            />
            <Input
              placeholder="Select Date and Time"
              size="md"
              type="date"
              w="30%"
              mx="8px"
              onChange={(e) => {
                const formatedDate = dayjs(e.target.value).format("YYYY-MM-DD");
                setDate(formatedDate);
              }}
            />

            {Data?.length != 0 && (
              <Box
                mx="10px"
                border="1px solid gray"
                borderRadius="8px"
                padding="10px"
              >
                <CSVLink
                  headers={headers}
                  data={Data?.length != 0 ? Data : []}
                  filename={"paid-report.csv"}
                  className="btn btn-primary"
                  target="_blank"
                >
                  Download
                </CSVLink>
              </Box>
            )}
            <LogoutMenu />
          </Flex>
        </Flex>

        <CTable
          selectedData={viewData}
          Columns={columns}
          Data={Data || []}
          path={"openModel"}
          Actions
          Title={``}
          subTitle=""
          btnTitle=""
          placeHolder=""
          noSearchBar={true}
          noFilter={true}
          footerBtnTitle
          filterList
          addButton
          addButtonTitle=""
          setPage={setPage}
          setPerPage={setPerPage}
          currentpage={pageNumber}
          setPageNumber={setPageNumber}
          noSecondSearchBar={true}
          isLoading={iaLoading}
          perPage={size}
          totalPage={Math.ceil(10 / 50)}
        />
      </div>
    </Layout>
  );
};

export default PaiedReport;
